import { Navigate, Outlet } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { authApi } from '../api/auth.api'
import { useAuth } from '../auth/AuthContext'
import { FullPageSpinner } from '../components/FullPageSpinner'

function useSetupStatus() {
  return useQuery({
    queryKey: ['auth', 'setup-status'],
    queryFn: async () => (await authApi.setupStatus()).data.setupRequired,
    staleTime: 30_000,
  })
}

export function SetupRoute() {
  const { data: setupRequired, isLoading } = useSetupStatus()
  if (isLoading) return <FullPageSpinner />
  if (setupRequired === false) return <Navigate to="/login" replace />
  return <Outlet />
}

export function PublicOnlyRoute() {
  const { data: setupRequired, isLoading: setupLoading } = useSetupStatus()
  const { isAuthenticated, isLoading: authLoading } = useAuth()

  if (setupLoading || authLoading) return <FullPageSpinner />
  if (setupRequired) return <Navigate to="/setup" replace />
  if (isAuthenticated) return <Navigate to="/" replace />
  return <Outlet />
}

export function ProtectedRoute() {
  const { data: setupRequired, isLoading: setupLoading } = useSetupStatus()
  const { isAuthenticated, isLoading: authLoading } = useAuth()

  if (setupLoading || authLoading) return <FullPageSpinner />
  if (setupRequired) return <Navigate to="/setup" replace />
  if (!isAuthenticated) return <Navigate to="/login" replace />
  return <Outlet />
}

export function PermissionRoute({ anyOf }: { anyOf: string[] }) {
  const { hasAnyPermission } = useAuth()
  if (!hasAnyPermission(anyOf)) return <Navigate to="/" replace />
  return <Outlet />
}
